import React, { useRef, useState, useEffect } from "react";
import { useMemo, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import PodCastAudioPlayer from "./PodCastAudioPlayer";
import PodCastTextContent from "./PodCastTextContent";
import BeatLoader from "react-spinners/BeatLoader";
import { getTranscriptDataFromUrl } from "./../common/api";
const TranscriptPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const [searchParams] = useSearchParams();
  const transcriptUrl = searchParams.get("url");
  const playMode = searchParams.get("play_mode");
  const abortControllerRef = useRef(null);
  const audioPlayerRef = useRef();
  const [data, setData] = useState({
    episode: {},
    loading: false,
    message: "",
    error: "",
  });
  const { episode, loading, message, error } = data;
  const getEpisode = useCallback(() => {
    getTranscriptDataFromUrl(
      {transcriptUrl,
      abortControllerRef})
      .then(results => {
        setData({
          ...data,
          episode: { ...results.data },
          loading: false,
          error: "",
          message: `${Object.keys(results.data).length ? "" : "No Results Found!"}`,
        })
      })
      .catch(err => {
        const { message } = err;
        setData({
          ...data,
          episode: [],
          loading: false,
          message: "",
          error: message,
        });
      });
  }, [transcriptUrl, abortControllerRef, data]);

  const content = useMemo(() => {
    return Object.keys(episode);
  }, [episode]);



  const timestampClickHandler = useCallback((position) => {

    if(playMode === 'spotify_link') {
      spotifyLinkJump(data.episode.podcast_urls.spotify, position);
      return;
    }

    texelioAudioPlayerJump(audioPlayerRef, position, setIsPlaying);

  }, [audioPlayerRef, setIsPlaying, data])

  useEffect(() => {
    const abortControllerRefCopy = abortControllerRef;
    getEpisode();
    return () => abortControllerRefCopy.current?.abort();
  }, [transcriptUrl]);

  const results = content?.length ? (
    <>
      <div className="sticky top-0 bg-linen w-full mx-auto px-2">
        <h1 className=" w-full truncate text-center capitalize text-customFontFourteen font-semibold my-2 underline">
          {episode.title}
        </h1>
        <PlayerBlock AudioPlayerComponentProps={{
            isPlaying,
            setIsPlaying,
            audioUrl: episode.audio_url,
          }}
          audioPlayerRef={audioPlayerRef} playMode={playMode} />
      </div>
      <div className="w-full mx-auto py-1">
        <PodCastTextContent
          podCastTextContentProps={{
            audioPlayerCopy: audioPlayerRef,
            audioText: episode.transcript,
            timestampClickHandler
          }}
        />
      </div>
    </>
  ) : (
    <div className="w-full bg-inherit">
      {loading && (
        <div className="w-full text-center">
          <BeatLoader color="#40464F" />
        </div>
      )}
      {message && (
        <p className="w-full text-customFontThree text-center text-black dark:text-white">
          {message}
        </p>
      )}
      {error && (
        <p className="w-full text-customFontThree text-red-500 text-center">
          {error}
        </p>
      )}
    </div>
  );

  return (
    <div className="min-h-screen w-full bg-linen overflow-auto p-2 text-black">
      {results}
    </div>
  );
};

const PlayerBlock = ({playMode,
  AudioPlayerComponentProps,
  audioPlayerRef
  }) => {

    if(playMode === 'spotify_link') {
      return "";
    }

    return <PodCastAudioPlayer
              AudioPlayerComponentProps={AudioPlayerComponentProps}
              ref={audioPlayerRef}
            />;

}

export default TranscriptPlayer;

function texelioAudioPlayerJump(audioPlayerRef, position, setIsPlaying) {
  if(!(audioPlayerRef.current))
  return;

  audioPlayerRef.current.audio.current.currentTime = position;
  audioPlayerRef.current.audio.current.play();
  setIsPlaying(true);
}

function spotifyLinkJump(spotify_base_link, position) {
  window.open(
    spotify_base_link.replace('{time_sec}',position), 
    'noopener,noreferrer');
}